import React from "react";
import PropTypes from "prop-types";
import i18next from "./locales/i18next";
import { I18nextProvider } from "react-i18next";

import { MaterialCard } from "@learningblocks/storybook-components/lib/GelComponents/MaterialCard";
import { getImageData } from "./component_data";

import style from "./style.module.scss";

/**
 *  i18n Configs
 */
const i18n = i18next;

const changeLang = (lang) => {
  i18n.changeLanguage(lang);
};

export class MaterialSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      materials: [],
      dir: "ltr",
    };
  }

  buildComponent = (data, index) => {
    const carddata = {
      key: index + "_" + data.props.type + "_" + data.component,
      id: data.props.id,
      fullName: i18n.t(
        Object.hasOwn(data.props, "fullName")
          ? data.props.fullName
          : data.props.type
      ),
      description: i18n.t(data.props.description),
      ariaLabel: Object.hasOwn(data.props, "ariaLabel")
        ? data.props.ariaLabel
        : "",
      isSolutionTube: Object.hasOwn(data.props, "solutionTube") ? true : false,
      solutionTube: Object.hasOwn(data.props, "solutionTube")
        ? data.props.solutionTube
        : {},
      contentID: "",
      image: Object.hasOwn(data.props, "solutionTube")
        ? null
        : getImageData(data.component, data.props),
    };
    return <MaterialCard {...carddata} />;
  };

  componentDidMount() {
    changeLang(this.props.lang);
    this.setState({
      dir: i18n.RTL_LANGs.includes(this.props.lang) ? "rtl" : "ltr",
    });
    this.doCompPart(this.props.materials, this.props.grouping);
  }

  doCompPart = (data, grouping) => {
    const groupArr = [];

    Object.keys(grouping).forEach((key, index) => {
      const compArr = [];
      grouping[key].components.forEach((component) => {
        if (Object.hasOwn(data, component)) {
          if (component == "CellSpreader") {
            compArr.push(this.buildComponent(data[component].components[0], 0));
          } else {
            data[component].components.forEach((comp, index) => {
              if (comp["component"] == "Solution") {
                if (!Object.hasOwn(grouping[key], "type")) {
                  compArr.push(this.buildComponent(comp, index));
                } else if (
                  grouping[key]["type"] == "Filled" &&
                  comp["props"]["volume"] > 0
                ) {
                  compArr.push(this.buildComponent(comp, index));
                } else if (
                  grouping[key]["type"] == "Empty" &&
                  comp["props"]["volume"] == 0
                ) {
                  compArr.push(this.buildComponent(comp, index));
                }
              } else {
                compArr.push(this.buildComponent(comp, index));
              }
            });
          }
        }
      });

      if (typeof compArr[0] != "undefined") {
        groupArr.push(
          <div aria-label={key} key={index} className={style.Category}>
            <h3 aria-label={key} className={style.CategoryHeading}>
              {key}
            </h3>
            <h6 className={style.CategoryDescription}>
              {grouping[key].description}
            </h6>
            <div aria-label={key} className={style.Group}>
              {compArr}
            </div>
          </div>
        );
      }
    });

    this.setState({
      materials: groupArr,
    });
  };

  render() {
    return (
      <I18nextProvider i18n={i18n}>
        <div className={style.Materials} dir={this.state.dir}>
          <p className={style.HelperText}>{i18n.t(this.props.helperText)} </p>
          {this.state.materials}
        </div>
      </I18nextProvider>
    );
  }
}

MaterialSection.propTypes = {
  materials: PropTypes.object.isRequired,
  helperText: PropTypes.string,
  grouping: PropTypes.object.isRequired,
  lang: PropTypes.oneOf([
    "ar",
    "az",
    "de",
    "en",
    "es",
    "fr",
    "it",
    "ja",
    "ko",
    "nl",
    "pl",
    "pt",
    "ru",
    "tr",
    "uk",
    "vi",
    "zh",
    "zu",
  ]),
};

MaterialSection.defaultProps = {
  lang: "en",
  helperText: "Click on the images to learn more about them.",
};
